import { Link } from "react-router-dom";
import { ArrowUpRight, ScrollText } from "lucide-react";

/**
 * Slim banner shown at the top of a deployment proposal page reminding readers
 * that the full Bridge Model story, founder background, and Chicago lineage
 * live on the home page — keeping the proposal focused on the local deployment.
 */
export default function LineageNote() {
  return (
    <section
      data-testid="lineage-note"
      className="bg-[#0A192F] text-[#F9F7F1] border-y border-[#D4AF37]/30"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 grid lg:grid-cols-12 gap-4 items-center">
        <div className="lg:col-span-9 flex items-start gap-4">
          <ScrollText className="h-5 w-5 text-[#D4AF37] mt-0.5 shrink-0" />
          <p className="text-sm leading-relaxed text-[#CBD5E1]">
            <span className="font-mono text-[10px] uppercase tracking-[0.24em] text-[#D4AF37] mr-2">
              About this proposal —
            </span>
            The Bridge Model&apos;s 65-year lineage (Chicago / Woodlawn / WCDC),
            George Broughton III&apos;s biography, and the founding story live
            on the parent site. This page is the proposal dossier — context,
            workforce pipeline, budget, federal strategy, and ask.
          </p>
        </div>
        <div className="lg:col-span-3 lg:text-right">
          <Link
            to="/#story"
            data-testid="lineage-note-cta"
            className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-[#D4AF37] hover:text-[#F9F7F1]"
          >
            Read the Bridge Story <ArrowUpRight className="h-3.5 w-3.5" />
          </Link>
        </div>
      </div>
    </section>
  );
}
